/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */
// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;
export default [[["فجرًا", "صباحًا", "ظهرًا", "بعد الظهر", "مساءً", "منتصف الليل", "ليلاً"], ["فجرًا", "ص", "ظهرًا", "بعد الظهر", "مساءً", "في المساء", "ل"], ["في الصباح", "صباحًا", "ظهرًا", "بعد الظهر", "مساءً", "في المساء", "ليلاً"]], [["فجرًا", "صباحًا", "ظهرًا", "بعد الظهر", "مساءً", "منتصف الليل", "ليلاً"], ["فجرًا", "ص", "ظهرًا", "بعد الظهر", "مساءً", "منتصف الليل", "ليلاً"], ["فجرًا", "صباحًا", "ظهرًا", "بعد الظهر", "مساءً", "منتصف الليل", "ليلاً"]], [["03:00", "06:00"], ["06:00", "12:00"], ["12:00", "13:00"], ["13:00", "18:00"], ["18:00", "24:00"], ["00:00", "01:00"], ["01:00", "03:00"]]];
